import { render, staticRenderFns } from "./ProofOfTrainingDocumentPreview.vue?vue&type=template&id=754c2994&scoped=true"
import script from "./ProofOfTrainingDocumentPreview.vue?vue&type=script&lang=ts"
export * from "./ProofOfTrainingDocumentPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c2994",
  null
  
)

export default component.exports